import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from 'styled-components'
import { Provider } from 'react-redux'

import App from './App.tsx'

import './i18n.ts'

import { store } from './stores/store.ts'
import { theme } from './styles/Theme.ts'
import { MaintenanceProvider } from './contexts/MaintenanceContext.tsx'
import MaintenanceWrapper from 'Components/MaintenanceWrapper'
import { GlobalStyles } from './styles/Global.ts'


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <MaintenanceProvider>
        <MaintenanceWrapper>
          <Provider store={store}>
            <ThemeProvider theme={theme}>
              <GlobalStyles />
              <App />
            </ThemeProvider>
          </Provider>
        </MaintenanceWrapper>
      </MaintenanceProvider>
    </Suspense>
  </React.StrictMode>
)
